import { useState, useEffect } from "react";
import { Link, NavLink } from "react-router-dom";
import "./burger.css";
import Socials from "./Socials";
import LogoImagic from "./LogoImagic";

export default function Burger(props) {
  const [idMenu, setIdMenu] = useState("imagic");
  const [scrollY, setScrollY] = useState(0);

  useEffect(() => {
    const handleScroll = () => {
      console.log(window.pageYOffset);
      setScrollY(window.pageYOffset);
    };
    
    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const survolMenu = (e) => {
    setIdMenu(e.currentTarget.id);
  }

  const openMenu = () => {
    document.querySelector(".pop").classList.remove("close");
    document.querySelector(".pop").classList.add("open");
  }

  const closeMenu = () => {
    document.querySelector(".pop").classList.remove("open");
    document.querySelector(".pop").classList.add("close");
  }

  const toTopClass = scrollY > 10 ? "" : "totopelm";

  return (
    <nav className={`${props.class} ${toTopClass}`}>
      <NavLink className="logo" to={"/"}>
        <LogoImagic id="logo-imagic" />
      </NavLink>
      <button onClick={openMenu} className="burgerIcon">
        <span className="topel"></span>
        <span className="bottomel"></span>
      </button>
      <div className="pop close">
        <button onClick={closeMenu} className="closeIcon">
          <svg xmlns="http://www.w3.org/2000/svg" width="26.414" height="26.414" viewBox="0 0 26.414 26.414">
            <g id="Groupe_2" data-name="Groupe 2" transform="translate(-470.293 -91.928)">
              <line id="Ligne_7" data-name="Ligne 7" x2="25" y2="25" transform="translate(471 92.635)" fill="none" stroke="var(--grey)" strokeWidth="2" />
              <line id="Ligne_8" data-name="Ligne 8" x2="25" y2="25" transform="translate(496 92.635) rotate(90)" fill="none" stroke="var(--grey)" strokeWidth="2" />
            </g>
          </svg>
        </button>
        <div className="mentions">
          <Link to="../politique-de-confidentialite" target="_blank" rel="noopener noreferrer">Politique de Confidentialité</Link>
          <Link to="../mentions-legales" target="_blank" rel="noopener noreferrer">Mentions légales</Link>
        </div>
        <NavLink onMouseOver={survolMenu} className="logo" id="imagic" to={"/"}>
          <LogoImagic id="logo-imagic" />
        </NavLink>
        <div className="menuIllustration" id={idMenu}>
          <img className="imagic-img" src="../image/poissonpapier.webp" alt="Imagic, illustration papier"></img>
          <img className="agence-img" src="../image/imagiciens2023.webp" alt="Imagiciens, agence de communication"></img>
          <img className="realisations-img" src="../image/nav/realisations.webp" alt="Réalisations graphiques"></img>
          <img className="laboratoire-img" src="../image/nav/laboratoire.webp" alt="Expérimentations de réalisations"></img>
          <img className="contact-img" src="../image/nav/contact.webp" alt="Contacter l'agence"></img>
        </div>
        <div className="menuNav">
          <ul className="menuList">
            <li className="main-item">
              <a onMouseOver={survolMenu} id="agence" href="/agence/">L'agence</a>
            </li>
            <li className="main-item">
              <NavLink onMouseOver={survolMenu} id="realisations" to="../realisations">Réalisations</NavLink>
            </li>
            <li className="under-item">
              <ul className="real-items">
                <li className="real-item">
                  <NavLink onMouseOver={survolMenu} id="realisations" to="../realisations/identite-visuelle">Identité visuelle</NavLink>
                </li>
                <li className="real-item">
                  <NavLink onMouseOver={survolMenu} id="realisations" to="../realisations/edition">Edition</NavLink>
                </li>
                <li className="real-item">
                  <NavLink onMouseOver={survolMenu} id="realisations" to="../realisations/web">Web</NavLink>
                </li>
                <li className="real-item">
                  <NavLink onMouseOver={survolMenu} id="realisations" to="../realisations/video">Vidéo</NavLink>
                </li>
                <li className="real-item">
                  <NavLink onMouseOver={survolMenu} id="realisations" to="../realisations/signaletique">Signalétique</NavLink>
                </li>
                <li className="real-item">
                  <NavLink onMouseOver={survolMenu} id="realisations" to="../realisations/packaging">Packaging</NavLink>
                </li>
                <li className="real-item">
                  <NavLink onMouseOver={survolMenu} id="realisations" to="../realisations/illustration">Illustration</NavLink>
                </li>
                <li className="real-item">
                  <NavLink onMouseOver={survolMenu} id="realisations" to="../realisations/photographie">Photographie</NavLink>
                </li>
              </ul>
            </li>
            <li className="main-item">
              <NavLink onMouseOver={survolMenu} id="laboratoire" to="../laboratoire">Laboratoire</NavLink>
            </li>
            <li className="main-item">
              <NavLink onMouseOver={survolMenu} id="contact" to="../contact">Contact</NavLink>
            </li>
          </ul>
          <Socials />
        </div>
      </div>
    </nav>
  );
}
